import fetch from '@/apiconfig/index';

export function ecompanyGetNamesByActiveUser(parameter) {
  return fetch({
    url: '/api/companystaff/ecompany/getNamesByActiveUser',
    method: 'get',
    params: parameter
  });
}

export function ecompanyGetLogoByCode(parameter) {
  return fetch({
    url: '/api/companystaff/ecompany/getLogoByCode',
    method: 'get',
    params: parameter
  });
}
// 请求滑块的图片
export function getRandomVerifyImage(parameter) {
    return fetch({
      url: '/api/companystaff/easyRegisterController/getRandomVerifyImage',
      method: 'get',
      params: parameter
    });
  }
// 验证滑块是否成功
export function verifyRandomImage(parameter) {
    return fetch({
      url: '/api/companystaff/easyRegisterController/verifyRandomImage',
      method: 'post',
      data: parameter
    });
  }